import {useTranslation} from 'react-i18next';
import {
  RatingQuestion,
  RATING_ICONS,
} from '../../../forms/components/AddEditForm/types';
import {SVG} from '../../../../constants/assetLists';
import { FormQuestion, FormQuestionRatingType } from '../../../../services/operations/forms';

/** Map icon type to its filled variant */
const FILLED_ICON_MAP: Record<string, string> = {
  star: SVG.filledStarIcon,
  heart: SVG.filledHeartIcon,
  smile: SVG.filledSmileIcon,
  glass: SVG.filledGlassIcon,
};

type Props = {
  question: FormQuestion;
  value: number | null;
  onChange: (value: number | null) => void;
};

function PublicRating({question, value, onChange}: Props) {
  const {t} = useTranslation();

  const { max: maxRating, icon } = question?.rating as FormQuestionRatingType;

  const ratingEntry =
    RATING_ICONS.find(r => r.value === icon) || RATING_ICONS[0];
  const emptyIcon = ratingEntry.emptyIcon;
  const filledIcon = FILLED_ICON_MAP[icon] || SVG.filledStarIcon;

  const handleSelect = (val: number) => {
    onChange(val);
  };

  const handleClear = () => {
    onChange(null);
  };

  return (
    <div className="flex flex-col gap-3 mt-3">
      {/* Rating icons row — centered */}
      <div className="flex flex-row-reverse flex-wrap md:flex-nowrap items-center justify-center gap-3 md:!gap-10">
        {Array.from({length: maxRating}, (_, i) => {
          const ratingVal = i + 1;
          const isFilled = value !== null && ratingVal <= value;

          return (
            <button
              key={ratingVal}
              type="button"
              onClick={() => handleSelect(ratingVal)}
              className="flex flex-col items-center gap-2 cursor-pointer bg-transparent border-none p-0">
              {/* Number label */}
              <span className="text-textColor">{ratingVal}</span>

              {/* Icon */}
              <img
                src={isFilled ? filledIcon : emptyIcon}
                alt={`${icon} ${ratingVal}`}
                className="w-[24px] h-[24px] object-contain"
              />
            </button>
          );
        })}
      </div>

      {/* Clear selection link */}
      <div className="flex">
        <button
          type="button"
          onClick={handleClear}
          className="text-linkBlue underline hover:opacity-80 transition-opacity bg-transparent border-none cursor-pointer p-0">
          {t('forms.public.clearSelection')}
        </button>
      </div>
    </div>
  );
}

export default PublicRating;
